module.exports = __webpack_public_path__ + "img/img17.f32cbfdc.svg";